module.exports = __webpack_public_path__ + "static/img/logo.48c011c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 1966
// module chunks = 3